import React from 'react'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import styled from "styled-components"
import Items from "../../constants/testimonials"

const SliderSmall = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true
      };
    return (
        <Wrapper>
            <Slider {...settings} className="slider">
            {Items.map((item, index) => {
              return (
                <div className="item-white" key={index}>
                  <h4>{item.name}</h4>
                  <div className="company">{item.company}</div>
                  <p>{item.comment}</p>
                </div>
              )
            })}
            </Slider>
        </Wrapper>
    )
}
const Wrapper = styled.div`
  width: 100%;
  background: var(--clr-white);
  @media screen and (min-width: 1025px) { display: none; }
  .slider {
      width: 75%;
      margin: 0 auto;
      padding: 0 10px;
  }
  
  .slick-arrow:before {color: var(--clr-primary-1); }
  h4 {
      font-weight: bold;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
    }
    .company {
      font-size: 12px;
      line-height: 190%;
      color: #828282;
      text-align: center;
    }
    p {
      margin-top: 10px;
      font-size: 14px;
      line-height: 200%;
    }
  
`

export default SliderSmall
